<template class="results-graph">
  <v-container fluid class="pa-0">
    <div align="left" class="stj-bar">
      <v-row no-gutters>
        <!-- Logo -->
        <v-col cols="12" md="2" class="d-flex align-center mb-2 mb-md-0" style="max-width: 225px;">
          <img class="stj-logo px-1 d-block" src="@/assets/STJsepia.png" alt="STJ Logo">
        </v-col>
        <!-- Fecha -->
        <v-col cols="12" sm="6" md="2" class="px-2">
          <div class="stj-label">Fecha</div>
          <v-select
            class="stj-select"
            :items="availableYears"
            v-model="selectedYear"
            dense hide-details outlined
            :menu-props="{ offsetY: true}"
          />
        </v-col>
        <!-- Magistrado -->
        <v-col cols="12" sm="6" md="2" class="px-2">
          <div class="stj-label">Magistrado</div>
          <v-select
            class="stj-select"
            :items="availableMagistrados"
            v-model="selectedMagistrado"
            dense hide-details outlined
            :menu-props="{ offsetY: true}"
          ></v-select>
        </v-col>
        <!-- P de genero -->
        <v-col cols="12" sm="6" md="2" class="px-2">
          <div class="stj-label">Persp. de género</div>
          <v-select
            class="stj-select"
            :items="availableGenero"
            v-model="selectedGenero"
            dense hide-details outlined
            :menu-props="{ offsetY: true}"
          ></v-select>
        </v-col>
        <!-- P de Infancia y Adolescencia -->
        <v-col cols="12" sm="6" md="2" class="px-2">
          <div class="stj-label">Persp. de Infancia y Adoles.</div>
          <v-select
            class="stj-select"
            :items="availableNinez"
            v-model="selectedNinez"
            dense hide-details outlined
            :menu-props="{ offsetY: true}"
          ></v-select>
        </v-col>
        <!-- Boton & Iconos -->
        <!-- <v-col cols="12" md="12" lg="auto" class="d-flex align-center justify-end mt-3 px-2"> -->
        <v-col cols="12" sm="6" md="2" class="d-flex align-center justify-end mt-3 px-2">
          <v-btn class="stj-btn mr-2 mt-4 d-none">
            Detalle
          </v-btn>
          <div class="stj-icons ml-8 d-flex">
            <!-- Home -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="stj-icon-btn" v-bind="attrs" v-on="on" @click="irHome();">
                  <v-icon>mdi-home</v-icon>
                </v-btn>
              </template>
              <span>Inicio</span>
            </v-tooltip>
          </div>
          <!-- <div class="stj-icons ml-8 d-flex">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="stj-icon-btn mr-1" v-bind="attrs" v-on="on">
                  <v-icon>mdi-filter-remove-outline</v-icon>
                </v-btn>
              </template>
              <span>Limpiar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="stj-icon-btn" v-bind="attrs" v-on="on" @click="irHome();">
                  <v-icon>mdi-home</v-icon>
                </v-btn>
              </template>
              <span>Inicio</span>
            </v-tooltip>
          </div> -->
        </v-col>
      </v-row>
    </div>

    <!-- ====================== RESULTADOS ====================== -->
    <div v-if="showReporte">
      <v-row ref="tableTop" class="mb-3">
        <v-col cols="12" md="7" sm="7">
          <h1 class="text-mgdo mb-5">Magistrados</h1>
          <h1 class="overline text-center">
            Año <b>{{ selectedYear }}</b>
          </h1>
        </v-col>

        <v-col cols="12" md="5" sm="5">
          <div class="bar-chart-title">Tocas totales por año</div>
          <div class="column-header">{{ selectedYear }}</div>
          <div class="text-center ml-1" style="max-width: 57px;">
            {{ totalTocas }}
          </div>
        </v-col>
      </v-row>
      <!-- Barra Tocas -->
      <v-row>
        <div class="d-block mw-100 bar-chart-title mx-3">Tocas</div>
      </v-row>

      <!-- ===================== GRAFICAS ===================== -->
      <v-row>
        <!-- barras / por magistrados -->
        <v-col cols="12">
          <v-sheet
            class="pa-5 mx-auto"
            color="white"
            elevation="10"
            height="auto"
            width="100%"
          >
            <div style="overflow-x: auto; overflow-y: auto;">
              <!-- ancho dinamico para que quepan todas las barras -->
              <div class="mx-auto" :style="{ width: chartPixelWidth + 'px' }">
                <column-chart
                  height="700px"
                  :data="sortedChartData"
                  :dataset="{
                    backgroundColor: '#118dff',
                    borderColor: '#118dff',
                    hoverBackgroundColor: '#118dff'
                  }"
                  :colors="['#118dff']"
                  label="Total de Tocas"
                  xtitle="Magistrados"
                  ytitle="Sentencias"
                  :library="chartOptions"
                  :messages="{ empty: 'No se Encontraron Resultados.' }"
                >
                </column-chart>
              </div>
            </div>
          </v-sheet>
        </v-col>
        <!-- ROW de botones -->
        <v-col cols="12">
          <v-btn-toggle v-model="barChartCategory" mandatory class="mb-3 d-flex justify-end">
            <v-btn class="stj-btn-bar mr-2 mt-4" value="delitos">delitos / acciones</v-btn>
            <v-btn class="stj-btn-bar mr-2 mt-4" value="materias">materias</v-btn>
            <v-btn class="stj-btn-bar mr-2 mt-4" value="acciones_especificas">acción <br> específica</v-btn>
            <v-btn class="stj-btn-bar mr-2 mt-4" value="acciones_simultaneas">acción <br> simultánea</v-btn>
          </v-btn-toggle>
        </v-col>
        <!-- pastel / por salas -->
         <v-col cols="12" md="6">
          <div class="d-block mw-100 bar-chart-title mb-3">Salas</div>
          <v-sheet
            class="pa-4 mx-auto h-md-sheet"
            color="white"
            elevation="10"
            height="auto"
            width="100%"
          >
            <!-- <div class="chart-wrapper"> -->
              <pie-chart
                height="717px"
                :key="$vuetify.breakpoint.width"
                :data="pieChartData"
                :colors="colorsPalette"
                :messages="{ empty: 'No se Encontraron Resultados.' }"
                :library="pieChartOptions"
              ></pie-chart>
            <!-- </div> -->
          </v-sheet>
        </v-col>
        <!-- <v-col cols="12" md="6">
          <div class="d-block mw-100 bar-chart-title mb-3">Salas</div>
          <v-sheet
            class="px-5 mx-auto"
            color="white"
            elevation="10"
            height="700px"
            width="100%"
          >
            <div class="d-flex justify-space-between" style="max-width: 530px; height: 530px;">
              <pie-chart
                class="mt-5"
                height="550px"
                :data="pieChartData"
                :colors="colorsPalette"
                :messages="{ empty: 'No se Encontraron Resultados.' }"
                :library="pieChartOptions"
              ></pie-chart>
            </div>
          </v-sheet>
        </v-col> -->
        <!-- barras horizontales / por delitos, materias, accion especifica y accion simultanea -->
        <v-col cols="12" md="6">
          <div class="d-block mw-100 bar-chart-title mb-3">{{ barChartTitle }}</div>
          <v-sheet
            class="pa-5 mx-auto"
            color="white"
            elevation="10"
            height="749"
            width="100%"
          >
            <v-row>
              <v-col class="text-left mt-1 ml-2">
                <div>Año: {{ selectedYear }}</div>
              </v-col>
              <!-- <v-col class="text-right mb-3">
                <div>
                  <v-btn color="success" @click="exportToExcel">Reporte en Excel</v-btn>
                </div>
              </v-col> -->
            </v-row>
            <!-- Contenedor con scroll nativo de Vuetify -->
            <v-card outlined style="max-height: 680px; overflow-y: auto" class="pa-2">
              <!-- <div class="text-caption text-center mb-2" style="color: #616161">
                Mostrando {{ displayedBarItems }} Delitos con mayor
              </div> -->
              <bar-chart
                :height="dynamicBarChartHeight"
                :data="barChartData"
                :dataset="{
                  backgroundColor: '#118dff',
                  borderColor: '#118dff',
                  hoverBackgroundColor: '#118dff'
                }"
                :colors="['#118dff']"
                :messages="{ empty: 'No se Encontraron Resultados.' }"
                :library="barChartOptions"
              ></bar-chart>
            </v-card>
          </v-sheet>
        </v-col>
      </v-row>
    </div>

    <!-- estado vacio / cargando -->
    <div v-else>
      <v-skeleton-loader type="image, article" v-if="loading" />
      <v-alert type="info" outlined v-else>
        No existen datos para visualizar la gráfica.
      </v-alert>
    </div>
  </v-container>
</template>
  
<script>
  export default {

  data: () => ({
    listTocas: [],
    selectedYear: null,
    availableYears: [],
    jsonYears: [],
    selectedYearForJson: null,
    jsonData: {},
    tocasAnualSalasData: {},
    anualDelitosData: {},
    anualDelitoMagistradoData: {},
    barChartCategory: "materias",
    showReporte: false,
    totalMagistrados: 0,
    loading: false,
    selectedMagistrado: "Todos",
    availableMagistrados: [],
    // colorsPalette: ['#63A4FF','#1A237E','#E67E22','#6A1B9A','#EC407A','#7E57C2','#FBC02D','#D32F2F','#00695C','#388E3C','#42A5F5',],
    colorsPalette: ['#118dff','#12239e','#e66c37','#6b007b','#e044a7','#744ec2','#d9b300','#d64550','#197278','#1aab40', '#15c6f4'],
    selectedGenero: "no filtrar",
    selectedNinez: "no filtrar",
    availableGenero: [
      // { value: "todos", text: "Todos" },
      { value: "no filtrar", text: "No Filtrar" },
      { value: "si", text: "Sí" },
      { value: "no", text: "No" },
    ],
    availableNinez: [
      // { value: "todos", text: "Todos" },
      { value: "no filtrar", text: "No Filtrar" },
      { value: "si", text: "Sí" },
      { value: "no", text: "No" },
    ],
    headers: [
      { text: "Magistrado", value: "magistrado", sortable: false },
      {
        text: "Total de tocas",
        value: "total_tocas",
        align: "center",
        sortable: false,
      },
    ],
    // opciones chart.js via chartkick :library
    pxPerBar: 45,
    minChartWidth: 900,
    heightPerItem: 0
  }),
  computed: {
    chartPixelWidth() {
      const bars = this.sortedChartData.length || 1;
      return Math.max(this.minChartWidth, bars * this.pxPerBar);
    },
    // registros del año seleccionado
    rowsForYear() {
      return Array.isArray(this.listTocas[this.selectedYear])
        ? this.listTocas[this.selectedYear]
        : [];
    },
    magOptions() {
      const set = new Set(this.rowsForYear.map(r => r.magistrado).filter(Boolean));
      return ['Todos', ...Array.from(set).sort((a, b) => a.localeCompare(b,'es'))];
    },
    filteredRows() {
      if (!this.selectedMagistrado || this.selectedMagistrado === 'Todos') {
        return this.rowsForYear;
      }
      const needle = this.selectedMagistrado.toLowerCase();
      return this.rowsForYear.filter(r => (r.magistrado || '').toLowerCase() === needle);
    },
    sortedChartData() {
      if (!Array.isArray(this.listTocas) || !this.listTocas.length) {
        this.showReporte = false;
        return [];
      }
      // filtrar los magistrados que si tienen resultados > 0
      const filtered = this.listTocas.filter(item =>
        Number(item.total_tocas) > 0
      );
        // si despues de filtrar no queda ningun resultado, ocultamos la grafica
        if (filtered.length === 0) {
          this.showReporte = false;
          return [];
        }
      this.showReporte = true;
      // ordenar de mayor a menor y devolver los datos formateados
      return filtered
        .map(item => [item.magistrado, item.total_tocas])
        .sort((a, b) => b[1] - a[1]);
    },
    // sortedChartData() {
    //   // Ordenar de mayor a menor sin afectar listTocas
    //   return [...this.listTocas].map((item) => [item.magistrado, item.total_tocas]);
    // },
    totalTocas() {
      return this.listTocas.reduce((acc, cur) => acc + cur.total_tocas, 0).toLocaleString("es-MX");
    },
    tocasTitle() {
      return "Tocas totales por año";
    },
    chartOptions() {
      const nf = new Intl.NumberFormat('es-MX')

      return {
        animation: { duration: 1000 },
        responsive: true,
        maintainAspectRatio: false,

        layout: { padding: { top: 16, right: 8, bottom: 8, left: 8 } },

        scales: {
          xAxes: [
            {
              ticks: { 
                autoSkip: false,
                fontColor: '#0d2b4c', // color
                fontSize: 14,         // tamaño px
                fontStyle: 'bold',    // 'normal' | 'bold' | 'italic' 
                maxRotation: 40, 
                minRotation: 40,
                padding: 0          // espacio extra 
              },
            },
          ],
          yAxes: [{ ticks: { fontStyle: 'bold', fontSize: 13 } }]
        },

        plugins: {
          datalabels: {
            color: '#000',
            font: { weight: 'bold', size: 13 },
            anchor: 'end',
            align: 'top',
            offset: -1,
            clamp: false,
            formatter: (value, ctx) => {
              // obtener escala Y (Chart.js 2)
              const chart = ctx.chart;
              const scales = chart.scales || {};
              const yScale =
                scales['y-axis-0'] ||
                Object.values(scales).find(s => (s.id || '').indexOf('y-axis') === 0);

              // si tenemos ticks, ocultar cuando el valor coincide con alguno
              if (yScale && Array.isArray(yScale.ticks)) {
                // ticks vienen como strings; normalizamos a numero
                const ticksNum = yScale.ticks
                  .map(t => Number(String(t).replace(',', '.')))
                  .filter(n => !isNaN(n));

                const v = Number(value);
                // tolerancia por si hay redondeos
                const EPS = 1e-9;
                const esTick = ticksNum.some(t => Math.abs(t - v) < EPS);
                if (esTick) return ''; // OCULTA solo cuando “va parejo” con el indicador
              }

              // en cualquier otro caso, mostrar el valor
              return value;
            }
          },
          // desactiva para barras
          legend: { display: false }
        },

        tooltips: {
          displayColors: false,
          bodyFontSize: 14,
          titleFontSize: 14,
          displayColors: false,
          callbacks: {
            label: function (tooltipItem) {
              return 'Total de Tocas: ' + tooltipItem.yLabel;
            }
          }
        },
      }
    },
    // chartOptions() {
    //   return {
    //     animation: { duration: 1000 },
    //     responsive: true,
    //     maintainAspectRatio: false,

    //     plugins: {
    //       datalabels: {
    //         color: '#000',
    //         font: { weight: 'bold', size: 15 },
    //         anchor: 'end',
    //         align: 'end',       
    //         offset: 8,
    //         clamp: true,
    //         formatter: (v) => v
    //       },
    //       legend: { display: false }
    //     },

    //     tooltips: {
    //       bodyFontSize: 14,
    //       titleFontSize: 14,

    //       displayColors: false,
    //       callbacks: {
    //         label: function (tooltipItem) {
    //           return 'Total de Tocas: ' + tooltipItem.yLabel;
    //         }

    //       }
    //     },
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     // chart.js v2.x (comun con Vuetify 2)
    //     scales: {
    //       xAxes: [
    //         {
    //           ticks: { 
    //             autoSkip: false,
    //             fontColor: '#0d2b4c', // color
    //             fontSize: 13,         // tamaño px
    //             fontStyle: 'bold',    // 'normal' | 'bold' | 'italic' 
    //             maxRotation: 40, 
    //             minRotation: 40,
    //             padding: 0          // espacio extra 
    //           },
    //         },
    //       ],
    //       yAxes: [{ ticks: { fontStyle: 'bold', fontSize: 13 } }]
    //     }
    //   };
    // },
    pieChartData() {
      if (!this.selectedYear) {
        return [];
      }

      const calculateFilteredTocas = (item, selectedGenero, selectedNinez) => {
        const total = Number(item.total_tocas || item.total || 0);
        const pGenero = Number(item.p_genero || 0);
        const pNinez = Number(item.p_ninez || 0);
        const pGenNin = Number(item.p_gen_nin || 0);

        if (selectedGenero === "no filtrar" && selectedNinez === "no filtrar") {
          return total;
        }

        const generoSi = selectedGenero === "si";
        const generoNo = selectedGenero === "no";
        const ninezSi = selectedNinez === "si";
        const ninezNo = selectedNinez === "no";

        let result = 0;

        if (generoSi && ninezSi) result = pGenNin;
        else if (generoSi && ninezNo) result = pGenero - pGenNin;
        else if (generoNo && ninezSi) result = pNinez - pGenNin;
        else if (generoNo && ninezNo) result = total - (pGenero + pNinez - pGenNin);
        else if (generoSi) result = pGenero;
        else if (generoNo) result = total - pGenero;
        else if (ninezSi) result = pNinez;
        else if (ninezNo) result = total - pNinez;

        return Math.max(0, result);
      };

      if (this.selectedMagistrado === "Todos" || !this.selectedMagistrado) {
        if (!this.tocasAnualSalasData[this.selectedYear]) {
          return [];
        }
        const salasData = this.tocasAnualSalasData[this.selectedYear];
        const processedData = Object.entries(salasData).map(([sala, item]) => {
          const newTotalTocas = calculateFilteredTocas(
            item,
            this.selectedGenero,
            this.selectedNinez
          );
          return [sala, newTotalTocas];
        });
        return processedData.sort((a, b) => b[1] - a[1]);
      } else {
        if (!this.jsonData[this.selectedYear]) {
          return [];
        }
        const magistrateData = this.jsonData[this.selectedYear].find(
          (item) => item.magistrado === this.selectedMagistrado
        );
        if (magistrateData && magistrateData.salas) {
          const salasData = magistrateData.salas;
          const processedData = Object.entries(salasData).map(([sala, item]) => {
            const newTotalTocas = this.calculateFilteredTocas(
              item,
              this.selectedGenero,
              this.selectedNinez
            );
            return [sala, newTotalTocas];
          });
          return processedData.sort((a, b) => b[1] - a[1]);
        }
        return [];
      }
    },
    barChartData() {
      if (!this.selectedYear) {
        return {};
      }

      let categoryDataRaw;

      if (this.selectedMagistrado === "Todos" || !this.selectedMagistrado) {
        if (!this.anualDelitosData[this.selectedYear]) return {};
        categoryDataRaw = this.anualDelitosData[this.selectedYear][this.barChartCategory];
      } else {
        if (
          !this.anualDelitoMagistradoData[this.selectedYear] ||
          !this.anualDelitoMagistradoData[this.selectedYear][this.selectedMagistrado]
        )
          return {};
        categoryDataRaw = this.anualDelitoMagistradoData[this.selectedYear][
          this.selectedMagistrado
        ][this.barChartCategory];
      }

      if (!categoryDataRaw) return {};

      const calculateFilteredTocas = (item, selectedGenero, selectedNinez) => {
        const total = Number(item.total_tocas || item.total || 0);
        const pGenero = Number(item.p_genero || 0);
        const pNinez = Number(item.p_ninez || 0);
        const pGenNin = Number(item.p_gen_nin || 0);

        if (selectedGenero === "no filtrar" && selectedNinez === "no filtrar") {
          return total;
        }

        const generoSi = selectedGenero === "si";
        const generoNo = selectedGenero === "no";
        const ninezSi = selectedNinez === "si";
        const ninezNo = selectedNinez === "no";

        let result = 0;

        if (generoSi && ninezSi) result = pGenNin;
        else if (generoSi && ninezNo) result = pGenero - pGenNin;
        else if (generoNo && ninezSi) result = pNinez - pGenNin;
        else if (generoNo && ninezNo) result = total - (pGenero + pNinez - pGenNin);
        else if (generoSi) result = pGenero;
        else if (generoNo) result = total - pGenero;
        else if (ninezSi) result = pNinez;
        else if (ninezNo) result = total - pNinez;

        return Math.max(0, result);
      };

      const data = {};
      for (const key in categoryDataRaw) {
        const item = categoryDataRaw[key];
        data[key] = calculateFilteredTocas(item, this.selectedGenero, this.selectedNinez);
      }

      const sortedData = Object.entries(data)
        .filter(([, value]) => value > 0)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 30);
      return Object.fromEntries(sortedData);
    },
    barChartTitle() {
      switch (this.barChartCategory) {
        case "delitos":
          return "Delitos / Acciones";
        case "materias":
          return "Materia y tipo juicios";
        case "acciones_especificas":
          return "Acción Específica";
        case "acciones_simultaneas":
          return "Acción Simultánea";
        default:
          return "";
      }
    },
    displayedBarItems() {
      return Object.keys(this.barChartData).length;
    },
    pieChartOptions() {
      const nf = new Intl.NumberFormat('es-ES');
      const isSmall = this.$vuetify.breakpoint.width < 1300;
      return {
        responsive: true,
        maintainAspectRatio: false,

        // padding del lienzo completo
        layout: { padding: { top: 10, right: 60, bottom: 10, left: 30 } },

        // padding independiente SOLO para la leyenda
        // lo leera el plugin del main.js
        legendPadding: isSmall ? { top: 5, right: 0, bottom: 5, left: 0 } : { top: 0, right: 20, bottom: 5, left: 70 },

        legend: {
          // position: 'right',
          position: isSmall ? 'bottom' : 'right', 
          labels: {
            usePointStyle: true,
            boxWidth: 10,
            fontSize: 13,
            padding: 10,
            filter: function (legendItem, chartData) {
              const ds = (chartData.datasets && chartData.datasets[0]) || { data: [] };
              const val = Number(ds.data[legendItem.index] || 0);
              return val > 0; // solo muestra si > 0
            },
          },
        },

        elements: { arc: { borderColor: '#fff', borderWidth: 0 } },

        tooltips: {
          callbacks: {
            label: (item, data) => {
              const ds  = data.datasets[item.datasetIndex] || { data: [] };
              const val = Number(ds.data[item.index] || 0);
              const tot = ds.data.reduce((a, b) => a + Number(b || 0), 0);
              const pct = tot ? ((val / tot) * 100).toFixed(2) : '0.00';
              return `${data.labels[item.index]}: ${nf.format(val)} (${pct}%)`;
            },
          },
        },

        plugins: {
          datalabels: {
            color: '#0d2b4c',
            anchor: 'end',
            align: 'end',
            offset: -1,
            clamp: true,
            font: { size: 13, weight: 'bold' },
            // alternar uno SI y uno NO:
            display: (ctx) => {
              const ds = ctx.dataset;
              const data = ds.data || [];
              const total = data.reduce((a,b)=>a + Number(b || 0), 0) || 0;
              const val = Number(data[ctx.dataIndex] || 0);
              const pct = total ? (val / total) * 100 : 0;

              const SHOW_ALWAYS   = 3.50; // %
              const SHOW_MIN      = 1.00; // %
              if (pct < SHOW_MIN) return false;         // < 1.00% = ocultar
              if (pct >= SHOW_ALWAYS) return true;      // ≥ 3.50% = mostrar

              // entre 1.00% y 3.49% --> alternar siguiendo la secuencia
              // contamos cuantas rebanadas previas estan en este rango
              let prevInBand = 0;
              for (let i = 0; i < ctx.dataIndex; i++) {
                const pv = Number(data[i] || 0);
                const pp = total ? (pv / total) * 100 : 0;
                if (pp >= SHOW_MIN && pp < SHOW_ALWAYS) prevInBand++;
              }
              // pares muestran, impares ocultan (!== 0 para invertir)
              return (prevInBand % 2) === 0;
            },
            // texto (valor + %)
            formatter: (value, ctx) => {
              const ds = ctx.dataset;
              const total = ds.data.reduce((a,b)=>a + Number(b || 0), 0) || 0;
              const pct = total ? (value / total) * 100 : 0;
              return `${value} (${pct.toFixed(2)}%)`;
            },
            // formatter: (value, ctx) => {
            //   const chart = ctx.chart;
            //   const meta  = chart.getDatasetMeta(ctx.datasetIndex);
            //   const arc   = meta.data[ctx.dataIndex];
            //   if (!arc || !arc._model) return '';

            //   // % del slice
            //   const ds    = ctx.dataset;
            //   const total = ds.data.reduce((a, b) => a + Number(b || 0), 0) || 0;
            //   const pct   = total ? (Number(value) / total) * 100 : 0;
            //   const txt   = `${nf.format(value)} (${pct.toFixed(2).replace('.', ',')}%)`;

            //   // Ángulo medio del slice
            //   const m      = arc._model;
            //   const midAng = (m.startAngle + m.endAngle) / 2;

            //   // Lado del pastel: cos(θ) > 0 → derecha, < 0 → izquierda
            //   const onRight = Math.cos(midAng) >= 0;

            //   // Contar cuántas etiquetas caen en cada lado
            //   let left = 0, right = 0;
            //   meta.data.forEach(a => {
            //     const mm = a._model;
            //     const mid = (mm.startAngle + mm.endAngle) / 2;
            //     (Math.cos(mid) >= 0) ? right++ : left++;
            //   });

            //   const countOnSide = onRight ? right : left;

            //   // Si en ese costado hay 2 o más, devolver en 2 líneas
            //   // (array = salto de línea en chartjs-plugin-datalabels)
            //   if (countOnSide >= 2) {
            //     return [nf.format(value), `(${pct.toFixed(2).replace('.', ',')}%)`];
            //   }

            //   // En caso contrario, una sola línea
            //   return txt;
            // },
          },
        },
      };
    },
    // pieChartOptions() {
    //   return {
    //     plugins: {
    //       datalabels: {
    //         color: "#000",
    //         font: { weight: "bold", size: 14 },
    //         anchor: "end",
    //         align: "end",
    //         offset: -40,
    //         formatter: (value, ctx) => {
    //           const dataset = ctx.chart.data.datasets[0];
    //           const total = dataset.data.reduce((a, b) => a + b, 0);
    //           const percentage = ((value / total) * 100).toFixed(1) + "%";
    //           return `${value} (${percentage})`;
    //         },
    //       },
    //     },
    //     elements: { arc: { borderColor: '#fff', borderWidth: 0 } },
    //     legend: {
    //       position: "top",
    //       labels: {
    //         padding: 8,
    //         fontSize: 13,
    //         boxWidth: 15,
    //         usePointStyle: true,
    //       },
    //     },
    //     layout: { padding: 20 },
    //   };
    // },
    barChartOptions() {
      const nf = new Intl.NumberFormat('es-MX');

      return {
        animation: { duration: 1000 },
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: { top: 8, right: 24, bottom: 8, left: 4 } },

        legend: { display: false },

        tooltips: {
          callbacks: {
            title: (items, data) => items[0].label,
            label: (tooltipItem, data) => {
              const ds = data.datasets[tooltipItem.datasetIndex];
              const val = Number(ds.data[tooltipItem.index] || 0);
              return ` ${nf.format(val)}`;
            },
          },
        },

        scales: {
          // En v2 se configuran xAxes/yAxes
          xAxes: [{
            ticks: {
              beginAtZero: true,
              padding: 6,
              fontSize: 12,
              callback: (v) => nf.format(v),
            },
            gridLines: { display: false, drawBorder: true },
          }],
          yAxes: [{
            ticks: {
              padding: 8,
              fontColor: '#0d2b4c',
              fontSize: 12,
              fontStyle: 'bold',
              callback: (label) => {
                const lbl = String(label || '').toUpperCase();
                const MAX = 30;
                return lbl.length > MAX ? lbl.slice(0, MAX - 1) + '…' : lbl;
              },
            },
            gridLines: { display: false, drawBorder: true },
          }],
        },

        // Requiere chartjs-plugin-datalabels ^0.7 (compatible con v2)
        plugins: {
          datalabels: {
            anchor: "end",
            align: "end",
            offset: 4,
            clamp: true,
            color: "#000",
            font: { weight: "bold", size: 12 },
            formatter: (v) => nf.format(v),
          },
        },
      };
    },
    dynamicBarChartHeight() {
      const numberOfItems = Object.keys(this.barChartData).length;
      const minHeight = 300; // Minimum height for the chart

      if(numberOfItems > 5) {
        this.heightPerItem = 25; // Height per bar
      } else {
        this.heightPerItem = 100; // Height per bar
      }
      return Math.max(minHeight, numberOfItems * this.heightPerItem) + "px";
    },
  },
  mounted() {
    // inyectar callback de Chart.js 2x:
    try {
      // === v2 ===
      if (this.chartOptions.scales && this.chartOptions.scales.xAxes) {
          this.chartOptions.scales.xAxes[0].ticks.callback = (value) =>
          this.wrapLabel(value, 39);
      }
    } catch (e) {
      console.warn('No se pudo inyectar el callback de wrap:', e);
    }
    this.initializeYears();
    this.fetchAndProcessData();
  },
  methods: {
    irHome () {window.location.href = '/';},
    wrapLabel(str, every = 26) {
      if (!str) return str;
      const parts = [];
      for (let i = 0; i < str.length; i += every) {
        parts.push(str.slice(i, i + every));
      }
      // Chart.js soporta array para ticks multilínea
      return parts;
    },
    initializeYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = currentYear; year >= 2010; year--) {
        years.push(year);
      }
      this.availableYears = years;
      this.jsonYears = years;
      this.selectedYear = currentYear;
      this.selectedYearForJson = currentYear;
    },
    async fetchAndProcessData() {
      this.loading = true;
      if (!this.selectedYear) return;
      try {
        const baseUrl = process.env.VUE_APP_GRAFICOS_CDN_URL;
        const magistradosUrl = `${baseUrl}/${this.selectedYear}/${this.selectedYear}_anual_magistrados.json`;
        const salasUrl = `${baseUrl}/${this.selectedYear}/${this.selectedYear}_anual_salas.json`;
        const delitosUrl = `${baseUrl}/${this.selectedYear}/${this.selectedYear}_anual_delitos.json`;
        const delitoMagistradoUrl = `${baseUrl}/${this.selectedYear}/${this.selectedYear}_anual_delito_magistrado.json`;

        const [
          magistradosRes,
          salasRes,
          delitosRes,
          delitoMagistradoRes,
        ] = await Promise.all([
          fetch(magistradosUrl, { cache: "no-store" }),
          fetch(salasUrl, { cache: "no-store" }),
          fetch(delitosUrl, { cache: "no-store" }),
          fetch(delitoMagistradoUrl, { cache: "no-store" }),
        ]);

        if (!magistradosRes.ok) throw new Error("Archivo de magistrados no encontrado");
        if (!salasRes.ok) throw new Error("Archivo de salas no encontrado");
        if (!delitosRes.ok) throw new Error("Archivo de delitos no encontrado");
        if (!delitoMagistradoRes.ok)
          throw new Error("Archivo de delito por magistrado no encontrado");

        this.jsonData = await magistradosRes.json();

        // normalizar nombres de magistrados
        Object.keys(this.jsonData).forEach(year => {
          if (!Array.isArray(this.jsonData[year])) return;
          this.jsonData[year] = this.jsonData[year].map(item => {
            return {
              ...item,
              magistrado: (item.magistrado || '')
                .replace(/^Mgda\.\s*/i, '')
                .replace(/^Mgdo\.\s*/i, '')
                .replace(/^Magda\.\s*/i, '')
                .replace(/^Secretaria de Acuerdos en Funciones de Magistrada\.\s*/i, '')
                .replace(/^Secretario de Acuerdos en Funciones de Magistrada\.\s*/i, '')
                .replace(/^Secretaria de Acuerdos en Funciones de Magistrado\.\s*/i, '')
                .replace(/^Secretario de Acuerdos en Funciones de Magistrado\.\s*/i, '')
                .trim()
            };
          });
        });

        this.tocasAnualSalasData = await salasRes.json();
        this.anualDelitosData = await delitosRes.json();
        this.anualDelitoMagistradoData = await delitoMagistradoRes.json();

        Object.keys(this.anualDelitoMagistradoData).forEach(year => {
          const yearData = this.anualDelitoMagistradoData[year];
          if (typeof yearData !== 'object' || Array.isArray(yearData)) return;

          const normalized = {};

          Object.keys(yearData).forEach(key => {
            // Eliminar prefijos
            const cleanKey = key
              .replace(/^Mgda\.\s*/i, '')
              .replace(/^Mgdo\.\s*/i, '')
              .replace(/^Magda\.\s*/i, '')
              .replace(/^Secretaria de Acuerdos en Funciones de Magistrada\.\s*/i, '')
              .replace(/^Secretario de Acuerdos en Funciones de Magistrada\.\s*/i, '')
              .replace(/^Secretaria de Acuerdos en Funciones de Magistrado\.\s*/i, '')
              .replace(/^Secretario de Acuerdos en Funciones de Magistrado\.\s*/i, '')
              .trim();

            // Guardar el mismo contenido con el nuevo nombre
            normalized[cleanKey] = yearData[key];
          });

          // Sobrescribir el año con las claves normalizadas
          this.anualDelitoMagistradoData[year] = normalized;
        });

            if (!this.magOptions.includes(this.selectedMagistrado)) {
                this.selectedMagistrado = 'Todos';
            }

        this.loadMagistrados();
        this.applyFilters();
      } catch (error) {
        console.error(error);
        this.listTocas = [];
        this.totalMagistrados = 0;
      } finally {
        this.loading = false;
        this.showReporte = true;
      }
    },
    loadMagistrados() {
      const data = this.jsonData[this.selectedYear] || [];

      // obtener nombres unicos de magistrados
      const magistrados = [...new Set(data.map(item => item.magistrado))];

      // ordenar alfabeticamente
      magistrados.sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }));

      // insertar "Todos" al inicio
      this.availableMagistrados = ["Todos", ...magistrados];
    },
    calculateFilteredTocas(item, selectedGenero, selectedNinez) {
      const total = Number(item.total_tocas || item.total || 0);
      const pGenero = Number(item.p_genero || 0);
      const pNinez = Number(item.p_ninez || 0);
      const pGenNin = Number(item.p_gen_nin || 0);

      if (selectedGenero === "no filtrar" && selectedNinez === "no filtrar") {
        return total;
      }

      const generoSi = selectedGenero === "si";
      const generoNo = selectedGenero === "no";
      const ninezSi = selectedNinez === "si";
      const ninezNo = selectedNinez === "no";

      let result = 0;

      if (generoSi && ninezSi) result = pGenNin;
      else if (generoSi && ninezNo) result = pGenero - pGenNin;
      else if (generoNo && ninezSi) result = pNinez - pGenNin;
      else if (generoNo && ninezNo) result = total - (pGenero + pNinez - pGenNin);
      else if (generoSi) result = pGenero;
      else if (generoNo) result = total - pGenero;
      else if (ninezSi) result = pNinez;
      else if (ninezNo) result = total - pNinez;

      return Math.max(0, result);
    },
    applyFilters() {
      if (!this.jsonData[this.selectedYear]) return;

      let data = [...this.jsonData[this.selectedYear]];

      // Filtrar por magistrado
      if (this.selectedMagistrado && this.selectedMagistrado !== "Todos") {
        data = data.filter((item) => item.magistrado === this.selectedMagistrado);
      }

      const processedData = data.map((item) => {
        const newTotalTocas = this.calculateFilteredTocas(
          item,
          this.selectedGenero,
          this.selectedNinez
        );
        return { ...item, total_tocas: newTotalTocas };
      });

      this.listTocas = processedData.sort((a, b) => b.total_tocas - a.total_tocas);
      this.totalMagistrados = this.listTocas.length;
      if (this.listTocas[0].total_tocas > 0) this.showReporte = true;

    },
    async exportToExcel() {
      try {
        console.log("Iniciando exportación a Excel...");

        const response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/reporte/reporte-excel`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              anio: this.selectedYear,
              magistrado: this.selectedMagistrado,
              genero: this.selectedGenero,
              ninez: this.selectedNinez,
            }),
          }
        );

        console.log("Status de respuesta:", response.status);
        console.log("OK?", response.ok);

        if (!response.ok) {
          // Intentar obtener el mensaje de error del backend
          let errorMessage = `Error ${response.status}`;
          try {
            const errorData = await response.json();
            errorMessage =
              errorData.error || errorData.message || JSON.stringify(errorData);
          } catch (e) {
            // Si no se puede parsear como JSON, obtener el texto
            const errorText = await response.text();
            errorMessage = errorText || `Error ${response.status}`;
          }
          throw new Error(errorMessage);
        }

        // Verificar el content type
        const contentType = response.headers.get("content-type");
        console.log("Content-Type:", contentType);

        if (
          !contentType ||
          !contentType.includes(
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          )
        ) {
          const text = await response.text();
          console.error("Respuesta inesperada:", text.substring(0, 200));
          throw new Error("El servidor no devolvió un archivo Excel");
        }

        const blob = await response.blob();
        console.log("Tamaño del blob:", blob.size, "Tipo:", blob.type);

        if (blob.size === 0) {
          throw new Error("El archivo Excel está vacío");
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Reporte_${this.selectedYear}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error("Error completo al exportar Excel:", error);
        alert("Error al exportar Excel: " + error.message);
      }
    },
  },
  watch: {
    selectedYear() {
      this.fetchAndProcessData();
    },
    selectedMagistrado(newValue) {
      if (newValue === null) {
        this.selectedMagistrado = "Todos";
      }
      this.applyFilters();
    },
    selectedGenero() {
      this.applyFilters();
    },
    selectedNinez() {
      this.applyFilters();
    },
  },
};
</script>

<style>
/* div#chart-2 canvas.chartjs-render-monitor {
    max-width: 3500px !important;
  } */
   .h-pie-chart {
    height: 550px;
   }
  /* .chart-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .pie-chart canvas {
    max-width: 100% !important;
    height: auto !important;
  } */
  .v-btn-toggle > .v-btn.v-btn {
    opacity: unset !important;
  }
  header {display: none !important;}
  .v-application--wrap img {display: none !important;}
  .v-card.v-card--flat.v-sheet.theme--light {display: none !important;}
  .bar-chart-title {
    visibility: visible;
    padding-bottom: 5px;
    font-size: 15.5pt;
    font-family: "Arial Black";
    color: rgb(230, 230, 230);
    border: none;
    margin-top: 0px;
    padding-left: 0px;
    cursor: default;
    text-align: center;
    background-color: rgb(46, 72, 109);
    font-weight: bold;
    width: 100%;
    height: 35.5px;
    align-content: center;
  }
  .text-mgdo {
    max-width: 638px;
    text-align: center;
    font-size: 2.3rem;
    font-weight: 500;
    font-family: 'Josefin Sans';
    font-variant: small-caps;
  }
  .column-header {
    text-align: end;
    padding: 1px 5px 11px;
    font-family: "Segoe UI", wf_segoe-ui_normal, helvetica, arial, sans-serif;
    font-size: 15px;
    font-weight: bold;
    color: rgb(37, 36, 35);
    background-color: rgb(255, 255, 255);
    box-shadow: rgb(46, 72, 109) 0px -7px 0px -5px inset;
    width: 57px;
    height: 30px;
    box-sizing: border-box;
    pointer-events: auto;
  }
  .v-application .overline {
    max-width: 638px;
    font-size: 1.8rem !important;
    text-transform: none !important;
    font-family: 'Josefin Sans' !important;
    font-variant: small-caps;
    color: rgb(175, 137, 54);
  }
  /* --------------------- Menu de logo y filtros --------------------- */
  /* Colores y estilos para parecerse al diseño */
  :root{
    --stj-blue: rgb(46, 72, 109);   /* fondo barra */
    --stj-gold: #c99a3c;   /* botones/bordes */
    --stj-input: #e9ebee;  /* fondo inputs */
  }
  .stj-bar {
    background: var(--stj-blue);
    border-radius: 14px;
    padding: 20px 20px 23.5px;
    margin: -11px -1px 21px -11px;
    color: #fff;
  }
  .stj-logo {
    height: 73px;
    width: auto;
    border-radius: 8px;
  }
  .stj-label {
    color: rgb(230, 230, 230);
    font-size: 15px;
    margin-bottom: 6px;
    letter-spacing: .2px;
  }
  .v_input.stj-select {
    height: 38px;
  }
  .stj-select .v-input__control {
    background: var(--stj-input);
    border-radius: 6px;
    height: 38px !important;
  }
  .stj-select .v-input__slot {
    border: 2px solid rgba(201,154,60,.5);
    border-radius: 6px !important;
    min-height: 36px !important;
    padding-left: 10px !important;
  }
  .stj-select .v-label { color: #607d8b !important; }
  .stj-select .v-select__selections { color: #37474f; }
  .stj-btn {
    background: var(--stj-gold) !important;
    color: rgb(46, 72, 109) !important;
    font-weight: 700;
    border-radius: 9px;
    padding: 8px 20px;
    text-transform: none;
  }
  .stj-btn-bar {
    background: #2e486d !important;
    color: #d9b300 !important;
    font-weight: 700;
    border-radius: 9px !important;
    padding: 8px 20px;
    text-transform: capitalize;
  }
  .stj-icon-btn {
    background: transparent !important;
    color: #fff !important;
  }
  /* iconos grandes y alineacion */
  .stj-icons .stj-icon-btn.v-btn.v-btn--icon {
    height: 54px !important; 
    width: 54px !important;
  }
  .stj-icons .v-icon {
    height: 44px !important; 
    font-size: 44px !important;
    width: 44px !important;
  }
  /* --------------------------- Responsive --------------------------- */
  @media (min-width: 600px) and (max-width: 660px) {
    .bar-chart-title .total-years {font-size: 13pt !important;}
  }
  @media (min-width: 960px) {
    .container.results-graph-margin {
      max-width: none !important;
    }
  }
  @media (max-width: 960px) {
    .h-md-sheet {
      height: unset !important;
    }
  }
  @media screen and (min-width: 1264px) {
    .v-application .overline {
      font-size: 2rem !important;
    }
  }
  @media screen and (min-width: 740px) {
    .letter-spacing {
      letter-spacing: 1px;
    }
  }
  /* @media (max-width: 400px) {
    .pie-chart canvas {
      width: 220px !important;
    }
  }
  @media (min-width: 401px) and (max-width: 599px) {
    .pie-chart canvas {
      width: 505px !important;
    }
  }
  @media (min-width: 600px) and (max-width: 767px) {
    .pie-chart canvas {
      width: 640px !important;
    }
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    .pie-chart canvas {
      width: 800px !important;
    }
  }
  @media (min-width: 1024px) and (max-width: 1439px) {
    .pie-chart {
      width: 690px !important;
      height: 470px !important;
    }
  }
  @media only screen and (min-width: 1440px) {
    .pie-chart {
      width: 630px !important;
      height: 630px !important;
      max-width: 100% !important;
      height: auto !important;
    }
  } */
</style>
  